import React from 'react';
import { Alert } from 'antd';
import { SettingsModal } from './SettingsModal';
import { SettingChange } from '../types';
import { SettingChangesStyle } from './styles';

type SettingsReviewModalProps = {
  open: boolean;
  title: string;
  changes: SettingChange[];
  isSaving: boolean;
  error: string | null;
  onSave: () => void;
  onClose: () => void;
};

export const SettingsReviewModal = (props: SettingsReviewModalProps): React.JSX.Element => {
  const { open, title, changes, isSaving, error, onSave, onClose } = props;
  return (
    <SettingsModal
      destroyOnClose
      open={open}
      title={title}
      width={700}
      okText="변경 사항 저장"
      cancelText="계속 편집"
      onOk={onSave}
      onCancel={onClose}
      confirmLoading={isSaving}
      cancelButtonProps={{ disabled: isSaving }}
      closable={!isSaving}
      maskClosable={!isSaving}
      keyboard={!isSaving}
    >
      <p>변경 내용을 확인해 주세요. 저장 후 새로 요청되는 설정부터 반영됩니다.</p>
      {error && <Alert type="error" showIcon message={error} />}
      <SettingChangesStyle>
        {changes.map((change, index) => (
          <div className="change-row" key={`${change.label}-${index}`}>
            <div className="change-label">{change.label}</div>
            <div className="change-values">
              <div>
                <small>변경 전</small>
                {change.before || '없음'}
              </div>
              <span className="change-arrow">→</span>
              <div>
                <small>변경 후</small>
                {change.after || '없음'}
              </div>
            </div>
          </div>
        ))}
      </SettingChangesStyle>
    </SettingsModal>
  );
};
